/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionDetails } from './TransactionDetails';
import {
    TransactionDetailsFromJSON,
    TransactionDetailsFromJSONTyped,
    TransactionDetailsToJSON,
} from './TransactionDetails';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface TransactionHistoryResponse
 */
export interface TransactionHistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof TransactionHistoryResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionHistoryResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionHistoryResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionHistoryResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionHistoryResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionHistoryResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof TransactionHistoryResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<TransactionDetails>}
     * @memberof TransactionHistoryResponse
     */
    data?: Array<TransactionDetails>;
}

/**
 * Check if a given object implements the TransactionHistoryResponse interface.
 */
export function instanceOfTransactionHistoryResponse(value: object): value is TransactionHistoryResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function TransactionHistoryResponseFromJSON(json: any): TransactionHistoryResponse {
    return TransactionHistoryResponseFromJSONTyped(json, false);
}

export function TransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionHistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TransactionDetailsFromJSON)),
    };
}

export function TransactionHistoryResponseToJSON(value?: TransactionHistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TransactionDetailsToJSON)),
    };
}

